import React from "react";
import "./Css/Gramsabha.css";

import img2 from "./Images/mukhyamantri1.jpg";   
import img1 from "./Images/mukhamantri2.jpg";   
import img3 from "./Images/mukhyamantri3.jpg";   
import img4 from "./Images/mukhyamatri4.jpg";   
import img5 from "./Images/mukhamantri5.jpg";  


export default function Mukhyamantri() {
  return (
    <section className="gramsabha-section">
      <h2 className="gramsabha-title">मुख्यमंत्री समृद्ध पंचायत राज योजनेअंतर्गत स्वच्छता शपथ मोहीम व ज्योत रॅली
</h2>

      <div className="gramsabha-layout">

        {/* LEFT BIG IMAGE */}
        <div className="item item1">
          <img src={img1} alt="" />
         
          
        </div>

        {/* TOP RIGHT - 2 IMAGES */}
        <div className="item item2">
          <img src={img2} alt="" />
        </div>

        <div className="item item3">
          <img src={img3} alt="" />
        </div>

        {/* CENTER BIG IMAGE */}
        <div className="item item4">
          <img src={img4} alt="" />
        </div>

        {/* RIGHT IMAGE */}
        <div className="item item5">
          <img src={img5} alt="" />
        </div>
      </div>
    </section>
  );
}
